import { call, put, takeLatest } from "redux-saga/effects";
import { setProfile } from "../../Containers/Client/action";
import { getS3UploadUrl, updateProfile } from "../../Domain/api";
import { uploadFile } from "../../Utils/awsHelper";
import { setError } from "./action";
import { UPDATE_PROFILE } from "./constants";

export function* doUpdateProfile({data, cbSuccess}){
    try {
        if(data.profilePicture) {
            const { urls } = yield call(getS3UploadUrl, {totalImage: 1});
            let array=[];
            array.push(data.profilePicture);
            data.profilePicture = uploadFile(urls, array)[0];
        }
        const result = yield call(updateProfile, data);
        yield put(setProfile(result.user))
        cbSuccess && cbSuccess();     
    } catch (error) {
        yield put(setError(error.response.data.message));
    }
}

export default function* settings() {
    yield takeLatest(UPDATE_PROFILE, doUpdateProfile);
}